import React from "react";
import { Alert, AlertIcon, Text } from "@chakra-ui/react";
import utils from "../utils";

export const CustomizedAlert = (props) => {
  return (
    <Alert
      status={props.status}
      rounded="md"
      variant="left-accent"
      borderTopWidth="1px"
      borderBottomWidth="1px"
      borderRightWidth="1px"
    >
      <AlertIcon />
      <Text
        dangerouslySetInnerHTML={{
          __html: utils.formatDisplayText(props.text),
        }}
      ></Text>
    </Alert>
  );
};
